import { createApp } from 'vue';
import RelatedLinksDisplay from './RelatedLinksDisplay.vue';
import RelatedLinksAdmin from './RelatedLinksAdmin.vue';
import { waitForBootstrap } from '../../bootstrap-helpers';
import '../../../../css/components/related-links-v2.less';

export function initRelatedLinksWidgets() {
    const elements = document.querySelectorAll('.related-links-widget-v2');

    if (!elements.length) return;

    elements.forEach(el => {
        const options = JSON.parse(el.dataset.options);

        const canAdmin =
            options.capabilities?.CanEditLinks === true ||
            options.capabilities?.CanConfigure === true;

        const component = canAdmin
            ? RelatedLinksAdmin
            : RelatedLinksDisplay;

        const props = canAdmin
            ? {
                initialWidget: options.widget,
                relatedLinksBaseUrl: options.relatedLinksBaseUrl,
                capabilities: options.capabilities,
                fileUploadOptions: options.fileUploadOptions
            }
            : {
                widget: options.widget
            };

        const app = createApp(component, props);

        waitForBootstrap(() => app.mount(el));
    });
}

function domReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
}

domReady(initRelatedLinksWidgets);